// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"721":"b8c9e81b","760":"52b70ca1"}[chunkId] + ".chunk.css";
};